import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'Rdx/store';

export const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
    const auth = useSelector((state: RootState) => state.auth);
    const hasAuthSession = Boolean(auth?.token) && Boolean(auth?.user);

    if (!hasAuthSession) {
        return <Navigate to="/signin" replace />;
    }

    return children;
};
